<template>
  <div v-if="props.items.length" class="m-bot-3">
    <WidgetSliderSwiper :length="props.items.length" :title="props.title">
      <template
        v-for="(slide, index) in props.items"
        :key="index"
        #[`slide-${index}`]
      >
        <PagesProductProductSwiperProductSlide :item="slide" />
      </template>
    </WidgetSliderSwiper>
  </div>
</template>

<script setup>
const props = defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  title: {
    type: String,
    default: '',
  },
})
</script>

<script>
export default {
  name: 'ProductSwiper',
}
</script>
